module.exports = __webpack_public_path__ + "img/vauraus@2x.cac21b8.png";